import * as Sentry from "@sentry/react";

let initialized = false;

/**
 * Initialize Sentry for the web app. Safe no-op when `VITE_SENTRY_DSN` is
 * unset (local dev). Captures unhandled exceptions and rejected promises
 * automatically; see `App.tsx` for the route-level error boundary and
 * `orgContext.tsx` for the user/org tag wiring.
 */
export function initSentry(): void {
  if (initialized) return;
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment:
      (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ??
      (import.meta.env.MODE as string | undefined) ??
      "development",
    // MUST match the release name that source maps were uploaded under (set
    // by Dockerfile: VITE_SENTRY_RELEASE = SENTRY_RELEASE = commit SHA).
    // `??` doesn't catch empty strings, which Vite emits for unset env vars,
    // so coerce empty/whitespace-only to undefined and let Sentry auto-detect
    // rather than tag events with an empty release that won't match maps.
    release:
      ((import.meta.env.VITE_SENTRY_RELEASE as string | undefined) ?? "").trim() ||
      undefined,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
  initialized = true;
}

export function isSentryEnabled(): boolean {
  return initialized;
}

export { Sentry };
